import { useState, useEffect, useCallback } from "react";
import axiosConfig from "../../../services/Axios";
import Select from "react-select";
import SelectTheme from "./SelectTheme";
import { useTranslation } from "react-i18next";

const SelectItemStates = ({
  onChange,
  cancelToken = null,
  emptyOpt = false,
  className,
  value = null,
}) => {
  const [options, setOptions] = useState();
  const [selectedValue, setSelectedValue] = useState(null);
  const { t } = useTranslation();

  const fetchRoles = useCallback(async (token) => {
    return await axiosConfig
      .get(
        process.env.REACT_APP_API_URL +
          "/api/items/available_states?pagination=false",
        {
          cancelToken: token,
        }
      )
      .then((response) => {
        let states = emptyOpt ? [{ label: t("global.all"), value: "" }] : [];

        response.data["hydra:member"].map((state) => {
          let opt = {
            value: state,
            label: t("items.state." + state.toLowerCase()),
          };
          states.push(opt);

          if (state === value) {
            setSelectedValue(opt);
          }
        });

        return states;
      })
      .catch(function (thrown) {
        if (axiosConfig.isCancel(thrown)) {
          console.log("ItemStates Request canceled : ", thrown.message);
        }
      });
  }, []);

  useEffect(() => {
    fetchRoles(cancelToken).then((response) => {
      setOptions(response);
    });
  }, [cancelToken]);

  return (
    <>
      <Select
        isSearchable={false}
        options={options}
        value={selectedValue}
        onChange={(e) => {
          onChange(e.value !== "" ? e.value : null);
          setSelectedValue(e);
        }}
        className={`${className} h-full w-full`}
        theme={SelectTheme}
      />
    </>
  );
};

export default SelectItemStates;
